<script setup lang="ts">
import { ref, computed } from "vue";
import { startLogin } from "@/lib/auth";
import LoadingButton from "./general/LoadingButton.vue";
import { useAuthStore } from "@/stores/authStore";
import { useAppSettingsStore } from "@/stores/appSettingsStore";
import LogoOnboarding from "./general/LogoOnboarding.vue";
import { DialogClose } from "reka-ui";
import { useRoute } from "vue-router";

const authStore = useAuthStore();
const appSettingsStore = useAppSettingsStore();
const route = useRoute();
const loading = ref(false);

const subscribeUrl = computed(() => appSettingsStore.settings?.url_register_and_subscribe);

const onLogin = () => {
  loading.value = true;
  startLogin({ path: route.fullPath });
};
</script>

<template>
  <div class="rounded-xl overflow-hidden w-full">
    <svg style="position: absolute; width: 0; height: 0">
      <clipPath id="header-clip-path" clipPathUnits="objectBoundingBox">
        <path
          d="M1,0 H0 V1 C0.151,0.944,0.321,0.913,0.5,0.913 C0.679,0.913,0.849,0.944,1,1 V0"
        ></path>
      </clipPath>
    </svg>
    <div
      class="h-60 bg-cover bg-center"
      style="
        background-image: url(/covers.png);
        clip-path: url(#header-clip-path);
      "
    />
    <div class="p-4">
      <LogoOnboarding class="w-56 mx-auto mb-16" />
      <div class="flex flex-col items-center">
        <LoadingButton class="w-full mb-2" :loading="loading" @click="onLogin">
          {{ $t("login_modal.login") }}
        </LoadingButton>
        <DialogClose
          class="btn-secondary w-full"
          @click="authStore.onCloseLoginModal"
        >
          {{ $t("common.close") }}
        </DialogClose>
        <p v-if="subscribeUrl" class="py-4 text-center">
          {{ $t("login_modal.no_subscription") }}
          <a
            :href="subscribeUrl"
            class="underline text-text-brand"
          >
            {{ $t("login_modal.subscribe") }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>
